const DayView = () => {
  return <div>Day View</div>;
};
export default DayView;
